<template>
    <div>
        <h5>Welcome back</h5>
        <small class="text-muted">Sign in with</small>
        <br><br>
        <a :href="login_link" class="btn btn-icon btn-rounded red text-white">
            <span>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 640 512">
                    <path fill="currentColor" d="M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z" class=""></path>
                </svg>
            </span>
        </a>
        <div class="my-3 text-muted text-sm text-muted">
            OR
        </div>
        <form role="form" @submit.prevent="login()">
            <div class="form-group">
                <input type="email" class="form-control" v-model="email" placeholder="Email" required>
            </div>
            <div class="form-group">
                <input type="password" class="form-control" v-model="password" placeholder="Password" required>
                <div class="my-3 text-right">
                    <router-link to="/forgot_password" tag="a">Forgot password?</router-link>
                </div>
            </div>
            <div class="checkbox mb-3">
                <label class="ui-check">
                    <input type="checkbox">
                    <i></i> Remember me
                </label>
            </div>
            <button type="submit" class="btn btn-primary mb-4">Sign in</button>
            <div>Do not have an account?
                <router-link to="/signup" tag="a">Sign up</router-link>
            </div>
        </form>
    </div>
</template>

<script type="text/javascript">

import Vue from 'vue';
import { isLoggedIn, login, login_link } from '@/utils/auth';

export default{
	name: 'Login',
	data() {
		return {
            login_link: login_link,
            email: '',
            password: '',
		}; 
  },
  methods: {
    login() {
        const path = process.env.API_LOCATION + "/login";
        const params = {
            email: this.email,
            password: this.password,
            remember_me: this.rememberMe,
        }

        this.$http.post(path, params)
        .then(() => {
            login();
            this.$router.push('/');
        })
        .catch(error => {
            try {
                var errorMessage = error.response.data.error;
            } catch (error) {
                console.log("Error is:", error);
                var errorMessage = "Unable to login.";
            }
            this.$emit("error", errorMessage);
        });
    },
  },

  created() {
    if(this.$route.query.activation_token) {
        const path = process.env.API_LOCATION + "/activate_account"
        
        this.$http.post(path, {token: this.$route.query.activation_token})
        .then(() => {
            this.$emit("success", "Successfully activated your account!");
        })
        .catch(error => {
            const errorMessage = error.response.data.error || "Unable to activate your account";
            this.$emit("error", errorMessage);
        })

        this.$route.query.activation_token = undefined;
    }
  }
};  

</script>


// WEBPACK FOOTER //
// src/components/Login.vue